import React from 'react';
import Icon from './Icon';

const QuickFilter = ({
  filter,
  handleFilterChange,
  clearFilter,
  placeholder,
}) => {
  return (
    <div className='creation-form quick-filter'>
      <div className='row'>
        <div className='full'>
          <label>
            Quick Filter{' '}
            {filter ? (
              <Icon icon='circle-xmark fa-sm' onClick={clearFilter} />
            ) : (
              <i className='fa-solid fa-filter' />
            )}
          </label>
          <input
            type='text'
            value={filter}
            onChange={handleFilterChange}
            placeholder={placeholder}
          />
        </div>
      </div>
    </div>
  );
};

export default QuickFilter;
